import React, { useState } from 'react';
import { t } from 'i18next';
import * as FeedbackService from '../../../services/FeedbackService';

type CompleteFeedbackButtonProps = {
  feedbackCanvas: any;
  onStatusUpdate: (updatedFeedback: any) => void;
  className?: string;
};

const CompleteFeedbackButton: React.FC<CompleteFeedbackButtonProps> = ({
  feedbackCanvas,
  onStatusUpdate,
  className = "btn btn-primary"
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isCompleted, setIsCompleted] = useState(feedbackCanvas.status === "completed");

  const updateStatus = (): Promise<void> => {
    return new Promise((resolve, reject) => {
      const updatedFeedback = {
        ...feedbackCanvas,
        status: "completed" as any,
      };

      FeedbackService.update(
        updatedFeedback,
        (): void => {
          console.log("Status atualizado com sucesso!");
          onStatusUpdate(updatedFeedback);
          resolve();
        },
        (error: unknown): void => {
          console.error("Erro ao atualizar status:", error);
          reject(error);
        }
      );
    });
  };

  const handleClick = async () => {
    if (isCompleted || isLoading) return;

    setIsLoading(true);

    try {
      await updateStatus();
      setIsCompleted(true);
    } catch (error) {
      console.error('Erro ao completar feedback:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const getButtonText = () => {
    if (isCompleted) {
      return 'Feedback Concluído';
    }
    if (isLoading) {
      return t('feedback.loading');
    }
    return t('feedback.actions.complete');
  };

  const isDisabled = isCompleted || isLoading;

  return (
    <button
      className={className}
      onClick={handleClick}
      disabled={isDisabled}
    >
      {isLoading && (
        <span
          className="spinner-border spinner-border-sm me-2"
          role="status"
          aria-hidden="true"
        ></span>
      )}
      {getButtonText()}
    </button>
  );
};

export default CompleteFeedbackButton;
